import styled from '@emotion/styled';
import tw from 'twin.macro';
import Button from './Button';

const Analytics = styled(Button)`
  ${tw`border-none`}
  color: #fff;
  width: 111px;
  height: 22px;
  border: none;
  font-size: 12px;
  margin-top: 15px;
  border-radius: 11px;
  background-color: #39a1b2;
`;

export default Analytics;
